export enum SelectSchemaMode {
  Datasets = 0,
  Odata = 1,
}
